<div [dfs]="'d:flex flex-direction:column h:100%'"
     class="_wrapper">
    <!-- heading -->
    <div [dfs]="'bg:16'"
         class="_heading">
        <div [style.float]="'right'"
             [dfs]="'m-l:2px'">

            <button (click)="toggleCollapse()"
                    [iCmsUiButton]="'transparent'"
                    [icon]="collapseIcon"
                    [dfs]="'c:12'"></button>

            <button (click)="close()"
                    [iCmsUiButton]="'transparent'"
                    [icon]="icons.Close"
                    [dfs]="'c:12'"></button>
        </div>
        <p [dfs]="'t:h2 c:1 m-v:4 m-l:2 d:inline-block'"
           class="_name">{{ data.title }}</p>
    </div>

    <!-- body -->
    <!-- that 100% here is needed to make scroll work in multiple trays -->
    <div [dfs]="'flex-grow:1 bg:w h:100%'"
         class="_content">
        <ng-template iCmsUtilViewContainer></ng-template>
    </div>
</div>